export default process.env.NODE_ENV === 'production' ?
  process.env.API_URL :
  `${window.location.protocol}//${window.location.host}/api`;
